import { ExpandLess, ExpandMore } from '@mui/icons-material'
import SportsSoccerIcon from '@mui/icons-material/SportsSoccer'
import {
  Collapse,
  ListItemIcon,
  ListItemText,
  MenuItem,
  MenuList,
} from '@mui/material'
import { useRouter } from 'next/router'
import { ReactNode, useContext, useState } from 'react'
import { useIntl } from 'react-intl'
import { TtoggleDrawerOnMobile } from '../../../containers/Sidebar/Sidebar'
import { useStyles } from '../../../containers/Sidebar/Sidebar.styles'
import { MixpanelContext } from '../../../contexts/mixpanel'
import { MenuComboBetCodes } from './sub-menu/MenuComboBetCodes'
import { MenuMappings } from './sub-menu/MenuMappings'

interface SportsbookSubMenuProps {
  hoverDrawer?: boolean
  openDrawer?: boolean
  permissions?: string[]
  toggleDrawerOnMobile: TtoggleDrawerOnMobile
  children?: ReactNode
}

export const SportsbookSubMenu = ({
  toggleDrawerOnMobile,
  openDrawer,
  hoverDrawer,
  children,
}: SportsbookSubMenuProps) => {
  const { pathname } = useRouter()
  const classes = useStyles({ openDrawer, hoverDrawer })
  const [open, setOpen] = useState(pathname.includes('/sportsbook'))
  const mxp = useContext(MixpanelContext)
  const { formatMessage } = useIntl()

  const handleClick = () => {
    setOpen(!open)
    mxp.track('click', {
      element: 'sportsbook menu click',
      section: 'sidebar',
    })
  }

  return (
    <MenuList aria-labelledby="nested-list-subheader" className={classes.root}>
      <MenuItem className={classes.menuItem} onClick={handleClick}>
        <ListItemIcon>
          <SportsSoccerIcon />
        </ListItemIcon>
        <ListItemText
          hidden={!openDrawer && !hoverDrawer}
          primary={formatMessage({ id: 'sportsbook.sidebar.title' })}
        />
        {open ? (
          <ExpandLess className={classes.expandIcon} />
        ) : (
          <ExpandMore className={classes.expandIcon} />
        )}
      </MenuItem>
      <Collapse
        in={open}
        timeout="auto"
        unmountOnExit
        hidden={!openDrawer && !hoverDrawer}
      >
        <MenuList component="div" disablePadding>
          {children}
          <MenuComboBetCodes
            pathname={pathname}
            toggleDrawerOnMobile={toggleDrawerOnMobile}
            nested={
              openDrawer || hoverDrawer ? classes.nested : classes.nestedClosed
            }
          />
          <MenuMappings
            pathname={pathname}
            toggleDrawerOnMobile={toggleDrawerOnMobile}
            nested={
              openDrawer || hoverDrawer ? classes.nested : classes.nestedClosed
            }
          />
        </MenuList>
      </Collapse>
    </MenuList>
  )
}
